jQuery(document).ready(function ($) {
    'use strict';

    if ($('.lightgallery-wrp').length > 0) {

        $(".lightgallery-wrp").lightGallery({
            selector: '.lightgallery',
            youtubePlayerParams: { modestbranding: 0, showinfo: 0, controls: 1 },
            vimeoPlayerParams: { byline : 0, portrait : 0 },
            preload: 1
        });

    }

    if ($('#ytbg').length > 0) {

        $(function(){
            $('[data-youtube]').youtube_background({
                'mobile':false
            });
        });

    }

});
